import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getTableCellNodeFromLexicalNode } from "@lexical/table";
import { $findMatchingParent } from "@lexical/utils";
import {
  $getSelection,
  $isParagraphNode,
  $isRangeSelection,
  COMMAND_PRIORITY_HIGH,
  INSERT_PARAGRAPH_COMMAND,
  LexicalEditor,
} from "lexical";
import { useEffect } from "react";

/**
 * Inside table cells, Enter inserts a line break instead of a new paragraph.
 * Cells therefore always hold a single paragraph, which keeps cell content
 * serializable to a single markdown table row using <br /> separators.
 */
export const registerTableCellLineBreak = (
  editor: LexicalEditor
): (() => void) =>
  editor.registerCommand(
    INSERT_PARAGRAPH_COMMAND,
    () => {
      const selection = $getSelection();
      if (!$isRangeSelection(selection)) {
        return false;
      }

      const anchorNode = selection.anchor.getNode();
      if (!$getTableCellNodeFromLexicalNode(anchorNode)) {
        return false;
      }

      // Only override plain paragraphs - other blocks (e.g. list items)
      // keep their default Enter behavior
      if (!$findMatchingParent(anchorNode, $isParagraphNode)) {
        return false;
      }

      selection.insertLineBreak();
      return true;
    },
    COMMAND_PRIORITY_HIGH
  );

function TableCellLineBreakPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerTableCellLineBreak(editor), [editor]);

  return null;
}

export default TableCellLineBreakPlugin;
